"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var device = {
  // Min
  mobile: "(min-width: 576px)",
  tablet: "(min-width: 768px)",
  tabletL: "(min-width: 992px)",
  laptop: "(min-width: 1200px)",
  // Max
  mobileMX: "(max-width: 575px)",
  tabletMX: "(max-width: 767px)"
};
exports.default = device;